import { DateTime } from 'luxon';

export const transformedDate = (date_to_transform) => {
    
    // 1. Check if the input is falsy (null, undefined, or empty string)
    if (!date_to_transform) {
      // Return an empty string or a placeholder like 'N/A'
      return ''; 
    }

    
    // String into a Date
    const date = new Date(date_to_transform);

    // 2. Check if the Date object is valid (handles invalid date strings)
    if (isNaN(date.getTime())) {
      return 'Invalid Date';
    }
    
    // Format date to "Month Day Year"
    const formattedDate = new Intl.DateTimeFormat("en-US", {
      month: "long", // Full month name
      day: "numeric", // Day of the month
      year: "numeric", // Full year
    }).format(date);
    
    return formattedDate;
}

export const calculateAge = (birthdayString) => {
    // Return null or 0 if the birthday string is missing
    if (!birthdayString) {
        return 0; // or null, depending on your preferred default value
    }

    const birthday = new Date(birthdayString);
    const today = new Date();

    // Check for invalid date
    if (isNaN(birthday.getTime())) {
        return 0; // or null
    }

    // Calculate the difference in years
    let age = today.getFullYear() - birthday.getFullYear();

    // Adjust the age if the birthday has not occurred yet this year
    const monthDifference = today.getMonth() - birthday.getMonth();
    const dayDifference = today.getDate() - birthday.getDate();

    // If the birthday hasn't occurred this year, subtract 1 from age
    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
        age--;
    }
    
    // Ensure age is not negative (e.g., if birthday is in the future)
    return Math.max(0, age);
}

/**
 * Returns the correct ISO 8601 week number and ISO week-numbering year
 * based on the middle of the FullCalendar view range.
 * @param {Date|string} dateInput - info.start or info.view.currentStart from FullCalendar
 */
export const getWeekAndYear = (dateInput) => {
  let dt = DateTime.fromJSDate(
    dateInput instanceof Date ? dateInput : new Date(dateInput)
  );

  // Advance by 3 days from the start of the view (Sunday -> Wednesday)
  // to ensure we hit the core of the active week and avoid Sunday boundary overlaps.
  dt = dt.plus({ days: 3 });

  return {
    week_number: dt.weekNumber, // ISO 8601 week
    year: dt.weekYear,          // ISO 8601 week-numbering year
  };
};